export const GENDER_CATEGORIES = [
  {
    id: 1,
    name: 'gender',
    value: 'Male'
  },
  {
    id: 2,
    name: 'gender',
    value: 'Female'
  }
]



// WEBPACK FOOTER //
// ./src/api/constants/Profile.js